import Api from './api';

export default class extends Api {

    constructor() {
        super()

        this.storagePrefix = 'notifications_'
    }

    toBeContacted(professionalId,params = {}) {
        return this.post('/api/professional/'+professionalId+'/to_be_contacted/notify', params)
            .then((response) => {
                return response.data;                
            });
    }

}


// WEBPACK FOOTER //
// ./application/assets/js/professional/api/notifications.js